import axios from 'axios'
import { orderBy } from 'lodash'
import {API_ADMIN} from '@/utils/constants/Api'
import {SubscriberModel} from '@/subscriber/models/SubscriberModel'
import { SubscriberAgreementModel } from '../models/SubscriberAgreementModel'
import { SubscriberBillingModel } from '../models/SubscriberBillingModel'
import { UserInvitationMemberModel } from '../../user/models/UserInvitationMemberModel'
import { SubscriberMemberModel } from '../models/SubscriberMemberModel'
import { MuvenRoleEnum } from '@c2b/muven-commons'
import { SubscriberBillingContactInformationModel } from '../models/SubscriberBillingContactInformationModel'
import { UserInvitationTempModel } from '../../user/models/UserInvitationTempModel'
import { SubscriberBackendCredentials } from '../interfaces/SubscriberBackendCredentials'

interface InterfacenetRequestOptions {
    clientId: string;
    clientSecret: string;
    clientName?: string;
    empresa?: string;
}

interface InterfacenetClientNameObject {
    clientName: string;
}

interface InterfacenetStore {
    key: string;
    value: string;
}

interface InterfacenetBranch {
    key: string;
    value: string;
}

interface InterfacenetPriceTable {
    key: number;
    value: string;
}

export default {
    getAgreement():Promise<SubscriberAgreementModel> {
        return axios.get(`${API_ADMIN}subscribers/agreement`)
            .then(({data}) => {
                return new SubscriberAgreementModel(data)
            })
    },
    acceptAgreement():Promise<any> {
        return axios.post(`${API_ADMIN}subscribers/agreement/accept`)
    },
    getSubscribers():Promise<SubscriberModel[]> {
        return axios.get(`${API_ADMIN}users/authenticated/subscribers`)
            .then(({data}) => {
                const subscribers = data.map((s:SubscriberModel) => {
                    return new SubscriberModel(s)
                })

                return orderBy(subscribers, ['name'], ['asc'])
            })
    },
    getSubscribersBillings():Promise<SubscriberBillingModel[]> {
        return axios.get(`${API_ADMIN}subscribers/billings`)
            .then(({data}) => {
                return orderBy(data.map((s:SubscriberBillingModel) => {
                    return new SubscriberBillingModel(s)
                }), ['dueDate'], ['desc'])
            })
    },
    clearCache():Promise<void> {
        return axios.delete(`${API_ADMIN}subscribers/clear_cache`)
    },
    forceChannelSync():Promise<void> {
        return axios.post(`${API_ADMIN}subscribers/synchronization`)
    },
    getBackendCredentials():Promise<any> {
        return axios.get(`${API_ADMIN}subscribers/backend/credentials`)
            .then(({data}) => {
                return data
            })
    },
    updateBackendCredentials(backendCredentials: SubscriberBackendCredentials):Promise<any> {
        return axios.post(`${API_ADMIN}subscribers/backend/credentials`, backendCredentials)
            .then(({data}) => {
                return data
            })
    },
    sendInvitation(userInvitation:UserInvitationMemberModel|UserInvitationTempModel):Promise<any> {
        return axios.post(`${API_ADMIN}subscribers/invite_user`, userInvitation)
            .then(({data}) => {
                return data
            })
    },
    getMemberList():Promise<SubscriberMemberModel[]> {
        return axios.get(`${API_ADMIN}subscribers/members`)
            .then(({data}) => {
                return (data || []).map((member: SubscriberMemberModel) => {
                    return new SubscriberMemberModel(member)
                }).filter((member: SubscriberMemberModel) => {
                    return member.canBeShown()
                })
            })
    },
    updateMemberRoles(memberId: number, memberRoleList: MuvenRoleEnum[]):Promise<SubscriberMemberModel> {
        return axios.patch(`${API_ADMIN}subscribers/members/${memberId}/roles`, memberRoleList)
            .then(({data}) => {
                return new SubscriberMemberModel(data)
            })
    },
    deleteMember(memberId: number):Promise<SubscriberMemberModel> {
        return axios.delete(`${API_ADMIN}subscribers/members/${memberId}`)
    },
    getBillingContactInformation():Promise<SubscriberBillingContactInformationModel> {
        return axios.get(`${API_ADMIN}subscribers`)
            .then(({data}) => new SubscriberBillingContactInformationModel(data))
    },
    updateBillingContactInformation(sub: SubscriberBillingContactInformationModel):Promise<SubscriberBillingContactInformationModel> {
        return axios.patch(`${API_ADMIN}subscribers`, sub)
            .then(({data}) => new SubscriberBillingContactInformationModel(data))
    },
    getInterfacenetClientName(req: InterfacenetRequestOptions):Promise<InterfacenetClientNameObject> {
        return axios.get(`${API_ADMIN}subscribers/backend/interfacenet/client_name?client_id=${req.clientId}&client_secret=${req.clientSecret}`)
            .then(({data}) => {
                return data;
            })
    },
    getInterfacenetStoreList(req: InterfacenetRequestOptions):Promise<InterfacenetStore[]> {
        return axios.get(`${API_ADMIN}subscribers/backend/interfacenet/empresas?client_id=${req.clientId}&client_secret=${req.clientSecret}&client_name=${req.clientName}`)
            .then(({data}) => {
                return data;
            })
    },
    getInterfacenetBranchList(req: InterfacenetRequestOptions):Promise<InterfacenetBranch[]> {
        return axios.get(`${API_ADMIN}subscribers/backend/interfacenet/filiais?client_id=${req.clientId}&client_secret=${req.clientSecret}&client_name=${req.clientName}&empresa=${req.empresa}`)
            .then(({data}) => {
                return data;
            })
    },
    getInterfacenetPriceTableList(req: InterfacenetRequestOptions):Promise<InterfacenetPriceTable[]> {
        return axios.get(`${API_ADMIN}subscribers/backend/interfacenet/tabelas_preco?client_id=${req.clientId}&client_secret=${req.clientSecret}&client_name=${req.clientName}`)
            .then(({data}) => {
                return data;
            })
    },
}
